import { render, staticRenderFns } from "./SalaryEdit.vue?vue&type=template&id=3d638342"
import script from "../../controllers/salary/salary-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/salary/salary-edit.js?vue&type=script&lang=js&external"
import style0 from "./SalaryEdit.vue?vue&type=style&index=0&id=3d638342&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports